import request from '@/utils/request'

// 搜索客户
export function customerSearch(data) {
  return request({
    url: `/api/customer/search`,
    method: 'PUT',
    data
  })
}
// 新增客户
export function addCustomer(data) {
  return request({
    url: `/api/customer/create`,
    method: 'PUT',
    data
  })
}
// 编辑客户
export function updateCustomer(data) {
  return request({
    url: `/api/customer/update`,
    method: 'PUT',
    data
  })
}
// 客户列表
export function getCustomerList(data) {
  return request({
    url: `/api/customer/list`,
    method: 'POST',
    data
  })
}

// 删除客户
export function deleteCustomer(id) {
  return request({
    url: `/api/customer/delete/${id}`,
    method: 'DELETE'
  })
}

// 保存房屋关联
export function bindCustomerAndHouse(customerId, data) {
  return request({
    url: `/api/customer/house/save/${customerId}`,
    method: 'PUT',
    data
  })
}

// 查询房屋关联
export function getCustomerHouse(customerId) {
  return request({
    url: `/api/customer/house/${customerId}`,
    method: 'GET'
  })
}

// 根据房屋编码查询产权人
export function queryCustomerByHouseCode(houseCode) {
  return request({
    url: `/api/customer/query-house/${houseCode}`
  })
}
